import * as React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import { ChipSwitch, ChipSwitchButton } from '../../../components/ChipSwitch'
import { OptionsQuery, OptionsSubpage, OptionsView } from '../types'

export function OptionsViewSwitcher({ activeView, subpage }: { activeView: OptionsView; subpage: OptionsSubpage }) {
  const [searchParams] = useSearchParams()

  const chainLink = React.useMemo(() => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set(
      OptionsQuery.View,
      [OptionsView.ChainByStrike, OptionsView.ListByStrike].includes(newParams.get(OptionsQuery.View) as OptionsView)
        ? OptionsView.ChainByStrike
        : OptionsView.ChainByDate
    )
    return newParams
  }, [searchParams])

  const listLink = React.useMemo(() => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set(
      OptionsQuery.View,
      [OptionsView.ChainByStrike, OptionsView.ListByStrike].includes(newParams.get(OptionsQuery.View) as OptionsView)
        ? OptionsView.ListByStrike
        : OptionsView.ListByDate
    )
    return newParams
  }, [searchParams])

  const plotLink = React.useMemo(() => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set(OptionsQuery.View, OptionsView.Plot)
    newParams.delete(OptionsQuery.Strike)
    newParams.delete(OptionsQuery.Expiry)
    return newParams
  }, [searchParams])

  return (
    <ChipSwitch label="View">
      <ChipSwitchButton
        as={Link}
        active={[OptionsView.ChainByDate, OptionsView.ChainByStrike].includes(activeView)}
        to={`?${chainLink}`}
      >
        Chain
      </ChipSwitchButton>
      <ChipSwitchButton
        as={Link}
        active={[OptionsView.ListByDate, OptionsView.ListByStrike].includes(activeView)}
        to={`?${listLink}`}
      >
        List
      </ChipSwitchButton>
      {subpage === OptionsSubpage.Prices ? (
        <ChipSwitchButton
          as={Link}
          theme="chipTransparent"
          active={activeView === OptionsView.Plot}
          to={`?${plotLink}`}
        >
          3D
        </ChipSwitchButton>
      ) : null}
    </ChipSwitch>
  )
}
